<script>
import VueDropify from "vue-dropify";
import { gender_type } from "@/helpers/global.variable";

// Custom Components
import UserService from "@/helpers/APIService/user.service";
import PageHeader from "@/components/page-header";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// profile Component
export default {
  page: {
    title: "Profile",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    VueDropify,
  },
  data() {
    return {
      title: "Profile",
      gender_type,
      first_name: "",
      last_name: "",
      email: "",
      mobile: null,
      gender: "",
      password: null,
      profile_picture: null,
      imgUrl: null,
      isBtnLoading: false,
    };
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getProfileData();
  },
  methods: {
    getProfileData() {
      this.email = this.user.user.email;
      this.first_name = this.user.user.first_name;
      this.last_name = this.user.user.last_name;
      this.mobile = this.user.user.mobile;
      this.gender = this.user.user.gender;
      this.profile_picture = this.user.user.profile_picture;
    },

    handleSubmit() {
      this.isBtnLoading = true;
      const profileData = new FormData();
      profileData.append("email", this.email);
      profileData.append("first_name", this.first_name);
      profileData.append("last_name", this.last_name);
      profileData.append("gender", this.gender);
      if (this.hotel == null) {
        profileData.append("password", this.password);
      }

      const mobile = this.mobile.replace(/[^0-9]/g, "");
      this.mobile = String(mobile).replaceAll(" ", "");
      profileData.append("mobile", this.mobile);
      if (this.imgUrl !== null) {
        profileData.append("profile_picture", this.imgUrl);
      }
      UserService.updateProfile(profileData)
        .then((response) => {
          this.email = response.email;
          this.first_name = response.first_name;
          this.last_name = response.last_name;
          this.mobile = response.mobile;
          this.gender = response.gender;
          this.profile_picture = response.profile_picture;
          const existing = localStorage.getItem("user");
          const existingJson = JSON.parse(existing);
          existingJson.user.first_name = response.first_name;
          existingJson.user.last_name = response.last_name;
          existingJson.user.email = response.email;
          existingJson.user.mobile = response.mobile;
          existingJson.user.gender = response.gender;
          existingJson.user.profile_picture = response.profile_picture;
          localStorage.setItem("user", JSON.stringify(existingJson));
          this.$root.$emit("change_image");
          Middleware.notification("Successfully updated !!", "success");

          this.isBtnLoading = false;
          setTimeout(() => {
            this.$router.go();
          }, 1000);
        })
        .catch((error) => {
          this.isBtnLoading = false;
          errorHandler(error);
        });
    },
    changeProfilePicture(event) {
      if (event[0] !== undefined) {
        this.imgUrl = event[0];
      } else {
        this.profile_picture = null;
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-xl-4 col-lg-12">
        <b-card>
          <div class="mb-2">
            <VueDropify
              @upload="changeProfilePicture($event)"
              :src="profile_picture ? profile_picture : null"
              message="Drop image here or click to select"
            />
          </div>
          <div class="row">
            <div class="col-lg-6">
              <h5 class="mb-0">Full Name</h5>
              <p class="text-primary">{{ first_name }} {{ last_name }}</p>
            </div>
            <div class="col-lg-6">
              <h5 class="mb-0">Mobile</h5>
              <p class="text-primary">{{ mobile }}</p>
            </div>
            <div class="col-lg-6">
              <h5 class="mb-0">Email</h5>
              <p class="text-primary">{{ email }}</p>
            </div>
            <div class="col-lg-6">
              <h5 class="mb-0">Gender</h5>
              <p class="text-primary">{{ gender }}</p>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-xl-8 col-ld-12">
        <b-card>
          <div class="row">
            <div class="col-lg-4">
              <b-form-group
                class="mb-3"
                label="First Name"
                label-for="first-input"
              >
                <b-form-input
                  id="first-input"
                  type="text"
                  autocomplete="off"
                  v-model="first_name"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-4">
              <b-form-group
                class="mb-3"
                label="Last Name"
                label-for="last-input"
              >
                <b-form-input
                  id="last-input"
                  type="text"
                  autocomplete="off"
                  v-model="last_name"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-4">
              <b-form-group
                class="mb-3"
                label="Email Address"
                label-for="email-input"
              >
                <b-form-input
                  id="email-input"
                  type="email"
                  autocomplete="off"
                  v-model="email"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-4" v-if="mobile !== null">
              <b-form-group
                class="mb-3"
                label="Number"
                label-for="number-input"
              >
                <vue-tel-input
                  v-model="mobile"
                  :autoDefaultCountry="false"
                  :dropdownOptions="{
                    showDialCodeInSelection: true,
                    showFlags: true,
                    width: '390px',
                    showSearchBox: true,
                  }"
                  :preferred-countries="['us', 'gb', 'ua']"
                ></vue-tel-input>
              </b-form-group>
            </div>
            <div class="col-lg-4">
              <b-form-group
                class="mb-3 form-label"
                id="input-group-1"
                label="Gender"
                label-for="Gender"
              >
                <b-form-select
                  class="form-select"
                  id="gender"
                  type="text"
                  autocomplete="off"
                  :options="gender_type"
                  v-model="gender"
                  placeholder="Select gender"
                >
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-lg-4" v-if="hotel == null">
              <b-form-group
                class="mb-3"
                label="Password"
                label-for="password-input"
              >
                <b-form-input
                  id="password-input"
                  type="text"
                  autocomplete="off"
                  v-model="password"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="row mt-2">
              <div class="col-lg-4 mt-4">
                <b-button
                  variant="primary"
                  class="me-2"
                  type="button"
                  @click="handleSubmit"
                  :class="{ disabled: isBtnLoading }"
                >
                  <i
                    class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                    v-if="isBtnLoading"
                  ></i>
                  Update
                </b-button>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>
